import { Injector, NgModule } from '@angular/core';
import { BootstrapModule } from './support/modules/bootstrap-module';
import { EntityService } from './entities/services/entity.service';
import { BootstrapService } from './bootstrap/bootstrap.service';
import { SettingService } from './settings/services/setting.service';
import { TranslateService } from '@ngx-translate/core';
import { BootstrapModuleContract } from './support/modules/interfaces/bootstrap-module.interface';
import { MenuModule } from './menu/menu.module';
import { SupportModule } from './support/support.module';
import { PluginsModule } from './plugins/plugins.module';
import { BootstrapModule as SystemBootstrapModule } from './bootstrap/bootstrap.module';
import { MenuService } from './menu/services/menu.service';
import { LocalizationService } from './localization/services/localization.service';
import { ConfigService } from './config/config.service';
import { CurrencyService } from './currency/services/currency.service';

@NgModule({
    imports: [
        MenuModule,
        PluginsModule,
        SupportModule,
        SystemBootstrapModule
    ],
    declarations: [],
    providers: [],
    exports: [
        MenuModule,
        PluginsModule,
        SupportModule,
        SystemBootstrapModule
    ],
})
export class CoreBootstrapModule extends BootstrapModule implements BootstrapModuleContract {

    public boot(injector: Injector) {
        const bootstrapService = injector.get(BootstrapService);

        /**
         * Check if the backend is updated
         * -> if so, remove all caches
         */
        bootstrapService.addToSequence(() => {
            return injector.get(ConfigService).checkVersion();
        }, true);

        // Load entities before start
        bootstrapService.addToSequence(() => {
            const entityService = injector.get(EntityService);

            return entityService.allWith(false, ['fieldsMeta', 'forms']);
        });

        // Load Settings before start
        bootstrapService.addToSequence(() => {
            const settingService = injector.get(SettingService);

            return settingService.init();
        });

        // Load currencies before start
        bootstrapService.addToSequence(() => {
            const currencyService = injector.get(CurrencyService);

            return currencyService.all();
        });

        const translate = injector.get(TranslateService);

        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('nl');
        translate.addLangs(['nl']);

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        // translate.use('en');
        translate.use('nl');

        const config   = this.injector.get(ConfigService);
        const endpoint = config.get('api_url') + '/lang/' + translate.currentLang + '.json';

        const localization = this.injector.get(LocalizationService);
        localization.setTranslations(endpoint, translate.currentLang);
    }

    public menus(menus: MenuService) {
        const menu = menus.register('sidebar');

        // Home
        menu.add('home', 'Home', 'home', {icon: 'pg-home', order: 1});

        // Configuration
        menu.add('config', 'Configuration', null, {heading: true, order: 90});

        // Users
        // menu.add('users', 'Users', 'users.index', {
        //     icon: 'fa fa-users', order: 90, permission: 'user.read'
        // });
        // menu.get('users')
        //     .add('users', 'Users', 'users.index', {icon: 'fa fa-users', permission: 'user.read'})
        //     .add('tenants', 'Tenants', 'tenants.index', {icon: 'fa fa-tenants', permission: 'tenant.read'})
        //     .add('permissions', 'Permissions', 'permissions.index', {
        //         icon: 'fa fa-list', permission: 'permission.read'
        //     })
        //     .add('roles', 'Roles', 'roles.index', {icon: 'fa fa-tags', permission: 'role.read'});

        // menu.add('settings', 'Settings', null, {
        //     icon: 'fa fa-cog', order: 95, permission: 'settings.read'
        // });
        // menu.get('settings')
        //     .add('configuration', 'Configuration', 'settings.index', {
        //         icon: 'fa fa-cogs', permission: 'settings.read'
        //     })
        //     .add('entities', 'Entities', 'entities.index', {
        //         icon: 'fa fa-cubes', permission: 'entities.read'
        //     });
    }
}

export interface ManifestInterface {
    name: string;
    timestamp: number;
    version: string;
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/core-bootstrap.module.ts